module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux-loader 插件列表")]), _vm._v(" "), _c('h2', [_vm._v("script-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v(".vue 文件的 script 部分代码处理")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("style-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_c('code', [_vm._v("<style></style>")]), _vm._v(" 代码处理")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("template-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("template代码替换处理")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于对"), _c('code', [_vm._v("<template></template>")]), _vm._v("模板代码做自定义处理")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("插件配置：")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h4', [_vm._v("js-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("项目里js文件处理，在babel-loader前进行处理")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', [_vm._v("template-feature-switch")]), _vm._v(" "), _c('p', [_vm._v("实现根据变量切换template代码")]), _vm._v(" "), _c('p', [_vm._v("参数：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', [_vm._v("vux-ui")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n  vux组件的配套工具，如果没有使用vux, 不需要添加。\n")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("该插件做了以下处理：")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("那么你就可以很方便地引入组件了：")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', [_vm._v("i18n")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h2', [_vm._v("less-theme")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n注意，path所在文件必须是简单的less变量对，不能import其他文件或者引入变量。\n")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("less 变量设置和替换")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于全局变量替换,  方便切换主题"), _c('br'), _vm._v("\n这意味着，你不再需要为每个页面引入全局的less文件了，你只需要设置lang为less就可以直接使用变量了")])]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', [_vm._v("插件配置：")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('h2', [_vm._v("duplicate-style")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("css 重复代码清除")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  建议使用vux组件的用户使用，因为vux直接引用less，最终构建的css文件确实会有冗余。\n")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("在webpack 构建完成后对生成的css文件使用cssnano进行重复样式清除。建议只在production环境下开启，因为dev环境没有必要。")])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('h2', [_vm._v("html-build-callback")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("html文件处理事件回调")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于在写入html(一般为index.html)文件前进行内容修改，比如替换特定内容"), _c('br'), _vm._v("\n比如写入js配置变量，改变cdn域名，将manifest文件直接写入html以减少请求等")])]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('h2', [_vm._v("build-done-callback")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("构建完成事件回调"), _c('br'), _vm._v("\n本质上是在webpack plugin的 done 事件后触发")])]), _vm._v(" "), _vm._m(24)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'script-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'VARIABLE'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'v2'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'style-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'black'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'white'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("name 插件名字， "), _c('code', [_vm._v("template-parser")])]), _vm._v(" "), _c('li', [_vm._v("replaceList 非必须，正则匹配列表，将直接调用 "), _c('code', [_vm._v("replace")]), _vm._v(" 方法进行替换")]), _vm._v(" "), _c('li', [_vm._v("fn 非必须，相比params更灵活的方法，可以对字符串进行处理后返回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[\n  name: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"template-parser\"")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceList")]), _vm._v(": [{\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/DeathToPM/g")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceString")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'微博-随时随地发现新鲜事'")]), _vm._v("\n  }, {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/呵呵我们压根没有底线/g")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceString")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'我是有底线的'")]), _vm._v("\n  }],\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("templateSource")]), _vm._v(") ")]), _vm._v("{\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" templateSource.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'智障'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'机智'")]), _vm._v(")\n  }\n]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'js-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'black'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'white'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("features")]), _vm._v("，变量列表，值只能为true或者false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'template-feature-switch'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("features")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature1")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature2")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("on")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"feature1\"")]), _vm._v(">")]), _vm._v("\n      AWESOME FEATURE 1 is ON\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("on")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("off")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"feature1\"")]), _vm._v(">")]), _vm._v("\n      AWESOME FEATURE 1 is OFF\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("off")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("那么当 feature1 为 true时，将输出 "), _c('code', [_vm._v("AWESOME FEATURE 1 is ON")]), _vm._v(", 反之则输出 "), _c('code', [_vm._v("AWESOME FEATURE 1 is OFF")]), _vm._v("。注意"), _c('code', [_vm._v("on")]), _vm._v("标签内不限定内容，可以为任何标签代码块，但"), _c('code', [_vm._v("避免在on off 里面再嵌套 on off")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果配合"), _c('code', [_vm._v("vux")]), _vm._v("使用，需要手动启用。默认不需要设置选项。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("配置"), _c('code', [_vm._v("babel")]), _vm._v("编译 vux 的js源码")]), _vm._v(" "), _c('li', [_vm._v("修改vue-loader为 "), _c('code', [_vm._v("vux-loader!vue-loader")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("import")]), _vm._v("组件调用解析为单组件引入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  name: 'vux-ui'\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 0.x\nimport Group from 'vux/src/components/group'\nimport Cell from 'vux/src/components/cell'\n\n// 2.x\nimport { Group, Cell } from 'vux'\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('p', [_vm._v("如果你只是调用中文语言的vux组件，那么你不需要做任何配置。")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("如果你需要调用英文语言的vux组件，需要配置语言")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'i18n'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxStaticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxLocale")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'en'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "start": "3"
    }
  }, [_c('li', [_vm._v("如果你想和demo站点一样可以写"), _c('code', [_vm._v("i18n")]), _vm._v("block，并且需要动态切换语言，那么需要配置插件抽取i18n的内容，并设置非静态替换")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'i18n'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxStaticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("staticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("extractToFiles")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/locales/components.yml'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("localeList")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'en'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'zh-CN'")]), _vm._v("]\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("然后你就可以引用"), _c('code', [_vm._v("vuex-i18n")]), _vm._v("插件实现多语言切换了。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("参考 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/main.js#L84-L96"
    }
  }, [_vm._v("main.js")]), _vm._v(" 及 "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vuex-i18n"
    }
  }, [_vm._v("vuex-i18n 文档")]), _vm._v("(仅当参考，你也可以使用其他i18n插件)。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("<style lang=\"less\">\n.info {\n color: @font-size;\n}\n</style>\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'less-theme'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/styles/theme.less'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'duplicate-style'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("events")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("done")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{\n      "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'done!'")]), _vm._v(")\n    }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'html-build-callback'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("events")]), _vm._v(": {\n   "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'after-html-processing'")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("data, cb")]), _vm._v(") ")]), _vm._v("{\n      data.html += "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'magic footer'")]), _vm._v("\n      cb("), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("null")]), _vm._v(", data)\n   }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("可用事件请参考 "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/html-webpack-plugin"
    }
  }, [_vm._v("html-webpack-plugin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'build-done-callback'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'done!'")]), _vm._v(")\n }\n}\n")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-480310f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-480310f4"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/plugins-193.vue
// module id = 2697
// module chunks = 510